import Cookie from 'js-cookie';
import { FC, ReactElement, useEffect } from 'react';

import { useActions } from '../../hooks/useActions';

const AuthProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const { checkAuth, checkAuthAndGetprofile } = useActions();

  useEffect(() => {
    const sessionToken = localStorage.getItem('st');
    if (sessionToken) checkAuthAndGetprofile();
  }, []);

  return <>{children}</>;
};

export default AuthProvider;
